module.exports = __webpack_public_path__ + "static/img/lunch.a09cabf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/scenario/lunch.png
// module id = 284
// module chunks = 1